import { memo } from 'react'


const MetaDashboard = memo(() => {

    return(
        <div className="mt-5">
            <h1>Campaign / media-buying / Insights / Targeting insights</h1>
        </div>
    )

})


export default MetaDashboard